import { useMutation } from "urql";
import {
  UpsertCrewMutationMutation,
  UpsertCrewMutationMutationVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useUpsertCrewMutation() {
  return useMutation(upsertCrewMutation);
}

export const upsertCrewMutation: TypedDocumentNode<
  UpsertCrewMutationMutation,
  UpsertCrewMutationMutationVariables
> = graphql(`
  mutation upsertCrewMutation(
    $identifier: String!
    $title: String!
    $joiningIdentifier: String!
    $bucket: String!
  ) {
    upsertCrew(
      identifier: $identifier
      title: $title
      joiningIdentifier: $joiningIdentifier
      bucket: $bucket
    ) {
      identifier
      joiningIdentifier
      title
      bucket
    }
  }
`);
